export default {"src":"https://images-cdn.curipod.com/d-bdb94e66/_next/static/media/monday.00e647f1.svg","height":159,"width":431};